import React, { Component } from "react";
import { Row, Col, Form, Button, Card, Input, message, Spin } from "antd";
import { Link } from "react-router-dom";
import CurrencyFormat from "react-currency-format";
import { connect } from "react-redux";
import ModalNoPolisi from "./Modal/ModalNoPolisi";
import axios from "../../../services/axios";
import ModalConfirmation from "./Modal/ModalConfirmation";
import ModalDialog from "./Modal/ModalDialog";

const FormItem = Form.Item;
const { TextArea } = Input;

class EApprovalCreate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      showModal: false,
      showModalConfirmation: false,
      showModalDialog: false,
      licensePlate: "",
      salesOtr: "",
      payload: null,
      profile: "",
    };
  }

  componentDidMount() {
    const { Auth } = this.props;
    this.getBranch(Auth.user.id);
  }

  getBranch = async (id) => {
    axios
      .get(`/user/${id}`)
      .then((result) => {
        this.setState({ profile: result ? result.data.profile : "" });
      })
      .catch((err) => {
        this.errorMessage(err);
      });
  };

  handleSubmit = async (e) => {
    const { salesOtr } = this.state;
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      this.setState({ isLoading: true });
      if (!err) {
        axios
          .post(`/car-sales`, { ...values, salesOtr })
          .then((result) => {
            // message.success(`Berhasil menambah approval`);
            this.setState({
              showModalConfirmation: false,
              showModalDialog: true,
            });
          })
          .catch((err) => {
            this.errorMessage(err);
          });
      }
      this.setState({ isLoading: false });
    });
  };

  callback(key, props) {
    props.form.resetFields();
  }

  errorMessage(e) {
    if (e.response) {
      if (e.response.data || e.response.message) {
        message.error(
          e.response.data.message || e.response.message || e.response.data
        );
      } else {
        message.error("Error Add Approval");
      }
    } else {
      message.error("Error Add Approval");
    }
  }

  render() {
    const { Auth, form, history } = this.props;
    const {
      showModal,
      showModalConfirmation,
      showModalDialog,
      payload,
      profile,
    } = this.state;
    const { getFieldDecorator, setFieldsValue } = form;

    return (
      <Card title="Add Approval" style={{ margin: "16px 0" }}>
        <Spin
          tip="Sedang menambahkan Approval Baru"
          spinning={this.state.isLoading}>
          <Form>
            <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
              <Col className="gutter-row" span={12}>
                <FormItem label="Cabang">
                  <Input
                    disabled={true}
                    value={(profile && profile.branch) || "-"}
                  />
                </FormItem>
              </Col>
              <Col className="gutter-row" span={12}>
                <FormItem label="Nama Salesman">
                  <Input
                    disabled={true}
                    value={Auth.user.name || "Nama Salesman"}
                  />
                </FormItem>
              </Col>
            </Row>
            <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
              <Col className="gutter-row" span={12}>
                <FormItem
                  label="No Polisi"
                  onClick={() => this.setState({ showModal: !showModal })}>
                  {getFieldDecorator("licensePlate", {
                    rules: [
                      {
                        required: true,
                        message: "No Polisi wajib diisi",
                      },
                    ],
                  })(<Input placeholder={"Masukkan No Polisi"} />)}
                </FormItem>
              </Col>
              <Col className="gutter-row" span={12}>
                <FormItem label="Harga yang diajukan customer">
                  {getFieldDecorator("salesOtr", {
                    rules: [{ required: true, message: "Harga wajib diisi" }],
                  })(
                    <div style={{ display: "flex" }}>
                      <div
                        style={{
                          padding: 10,
                          backgroundColor: "#f5f5f5",
                          borderRadius: "5px 0px 0px 5px",
                        }}>
                        Rp.
                      </div>
                      {/*<Input />*/}
                      <CurrencyFormat
                        style={{
                          border: "1px solid #d9d9d9",
                          borderRadius: "0px 5px 5px 0px",
                          width: "100%",
                          paddingLeft: 10,
                        }}
                        value={this.state.salesOtr}
                        thousandSeparator={"."}
                        decimalSeparator={","}
                        // prefix={'Rp.'}
                        placeholder={"00.00"}
                        onValueChange={(values) => {
                          const { formattedValue, value, floatValue } = values;
                          // formattedValue = $2,223
                          // value ie, 2223
                          this.setState({
                            salesOtr: !isNaN(floatValue) ? floatValue : 0,
                          });
                        }}
                      />
                    </div>
                  )}
                </FormItem>
              </Col>
            </Row>
            <FormItem label="Notes">
              {getFieldDecorator("salesNotes", {
                rules: [{ required: true, message: "Notes wajib diisi" }],
              })(<TextArea rows={4} placeholder={"Masukkan Notes Anda"} />)}
            </FormItem>

            <Row type="flex" justify="end">
              <Col>
                <Link to={"/home/e-approval/selling-system"}>
                  <Button style={{ margin: "0 10px" }}>Cancel</Button>
                </Link>
                <Button
                  htmlType="button"
                  type="primary"
                  onClick={(e) =>
                    this.setState({ payload: e, showModalConfirmation: true })
                  }>
                  Save
                </Button>
              </Col>
            </Row>
          </Form>
        </Spin>

        <ModalNoPolisi
          showModal={this.state.showModal}
          history={history}
          toggleShowModal={(value, licensePlate) => {
            setFieldsValue({ licensePlate });
            this.setState({
              showModal: value,
              licensePlate: licensePlate
                ? licensePlate
                : getFieldDecorator("licensePlate"),
            });
          }}
        />

        <ModalConfirmation
          showModal={showModalConfirmation}
          title={"Ajukan Diskon"}
          buttonText={"Yakin"}
          buttonTextCancel={"Batal"}
          caption={"Apakah anda yakin akan mengajukan diskon?"}
          toggleShowModal={(value) =>
            this.setState({ showModalConfirmation: value })
          }
          handleAction={() => this.handleSubmit(payload)}
        />

        <ModalDialog
          showModal={showModalDialog}
          caption={"Discount Successfully Requested"}
          toggleShowModal={(value) => {
            this.setState({ showModalDialog: value });
            this.props.history.push(`/home/e-approval/selling-system`);
          }}
        />
      </Card>
    );
  }
}

let mapStateToProps = ({ Auth }) => ({ Auth });

export default Form.create()(connect(mapStateToProps)(EApprovalCreate));



// WEBPACK FOOTER //
// src/components/Dashboard/EApproval/EApprovalCreate.js